<template>
    <section class="notenartausgabe-sv">
        <template v-if="sv_id && werk_id">
            <template v-if="Object.keys(items).length > 0">
                <div v-for="(noten_group, key) in items" class="noten-group" :key="key">
                    <b>{{getNotenDescription(noten_group[0].noten_werk, noten_group[0].komponist, noten_group[0].ausgabe)}}</b>
                    <Table
                        :fields="fields"
                        :items="noten_group"
                        :isBusy="busy"
                        striped
                        :refresh="refresh"
                    >
                        <template v-slot:head(returned)="{row: row}">
                            <span
                                v-b-tooltip.hover
                                title="Aktuell verfügbare Anzahl an Noten im Archiv"
                            >{{row.label}}</span>
                        </template>

                        <template v-slot:head(anzahl)="{row: row}">
                            <span
                                v-b-tooltip.hover
                                title="Grundsätzlich verfügbare Anzahl an Noten im Archiv, bereits ausgegebene eingeschlossen"
                            >{{row.label}}</span>
                        </template>

                        <template v-slot:returned="{row: row}">
                            <b-input
                                class="issued-input"
                                size="sm"
                                placeholder="Ausgabeanzahl"
                                v-model="row.item.returned"
                                @input="changedValues(row.item)"
                            />
                            /{{row.item.total}}
                        </template>

                        <template v-slot:rueckgabedatum="{row: row}">
                            <b-input
                                type="date"
                                size="sm"
                                placeholder="Rückgabedatum"
                                v-model="row.item.rueckgabedatum"
                                @input="changedValues(row.item)"
                            />
                        </template>

                        <template v-slot:geliehen="{row: row}">
                            <template v-if="row.item.geliehen == 1">
                                <font-awesome-icon icon="check" />
                            </template>
                            <template v-else>
                                <font-awesome-icon icon="minus" />
                            </template>
                        </template>
                    </Table>
                </div>
            </template>
            <template v-else>
                <CenteredMessage :spinner="busy">
                    <template v-if="busy">Notendaten werden geladen...</template>
                    <template
                        v-else
                    >Es wurden keine offenen Ausgaben zu diesem Konzert oder Stimmvertreter gefunden</template>
                </CenteredMessage>
            </template>
        </template>
        <template v-else>
            <b-alert
                show
                variant="warning"
            >Sie müssen zunächst einen Stimmvertreter und ein Werk auswählen, zu welchem Noten ausgegeben wurden</b-alert>
        </template>
    </section>
</template> 

<script>
import CommonView from "@/mixins/CommonView/CommonView";
import NotenverwaltungCommon from "@/mixins/NotenverwaltungCommon/NotenverwaltungCommon";
import { ApiFactory } from "@/api/ApiFactory.js";
import CenteredMessage from "@/components/CenteredMessage/CenteredMessage";
import Table from "@/components/Table/Table";

const NotentransferSVApi = ApiFactory.get("notentransferSV");

export default {
    name: "NotenartrücknahmeSV",
    props: ["sv_id", "werk_id", "notenId", "notentyp"],
    mixins: [CommonView, NotenverwaltungCommon],
    components: {
        CenteredMessage,
        Table
    },
    data() {
        return {
            api: NotentransferSVApi,
            fields: [
                { key: "description", label: "Version", sortable: true },
                { key: "returned", label: "Anzahl / aktuell Ausgegeben" },
                { key: "anzahl", label: "Gesamtbestand", class: "text-right" },
                { key: "rueckgabedatum", label: "Rückgabedatum" },
                { key: "archivnr", label: "Archiv-Nr." },
                {
                    key: "geliehen",
                    label: "geliehen",
                    sortable: true,
                    class: "text-center"
                },
                { key: "geliehen_von", label: "geliehen von", sortable: true }
            ],
            refresh: false
        };
    },
    watch: {
        sv_id: {
            handler() {
                this.fetch();
            }
        },
        werk_id: {
            handler() {
                this.fetch();
            }
        }
    },
    methods: {
        async fetch() {
            if (this.sv_id && this.werk_id) {
                this.busy = true;
                const response = await this.api.getTransactionsForConcert(
                    this.sv_id,
                    this.werk_id
                );
                if (response.ok) {
                    var items = response.json.collection;
                    if (items) {
                        items = items.map(item => this.process(item));
                        if (this.notenId) {
                            items = items.filter(
                                item => item.noten_id === this.notenId
                            );
                        }
                        if (this.notentyp) {
                            items = items.filter(
                                item => item.notentyp === this.notentyp
                            );
                        }

                        items = items.reduce(function(h, obj) {
                            h[obj.noten_id] = (h[obj.noten_id] || []).concat(
                                obj
                            );
                            return h;
                        }, {});
                        this.items = items;
                    } else {
                        this.items = [];
                    }
                }
                this.busy = false;
            }
        },
        process(item) {
            item.rueckgabedatum = this.$moment().format("YYYY-MM-DD");
            item.returned = null;
            return item;
        },
        changedValues(obj) {
            if (!obj.rueckgabedatum) {
                obj.rueckgabedatum = null;
            }
            if (!obj.returned) {
                obj.returned = null;
            }
            if (parseInt(obj.returned) > parseInt(obj.total)) {
                obj._cellVariants = { returned: "danger" };
                this.refresh = !this.refresh;
            } else {
                obj._cellVariants = { returned: "" };
                this.refresh = !this.refresh;
            }
            this.$emit("update", obj);
        }
    }
};
</script>